module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "ded"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ctag1"
  }, [_vm._v("With Love to")]), _vm._v(" "), _c('div', [_c('br')]), _c('div', {
    staticClass: "ctag1"
  }, [_vm._v("PEGGY LEACH")]), _vm._v(" "), _c('div', {
    staticClass: "ctag1"
  }, [_c('i', [_vm._v("without whom this book and our business would not have been possible.")])]), _vm._v(" "), _c('div', [_c('br')]), _c('div', {
    staticClass: "ctag1"
  }, [_vm._v("GORDON AND BONNIE NEGEN")]), _vm._v(" "), _c('div', {
    staticClass: "ctag1"
  }, [_c('i', [_vm._v("for their unfailing support, including the many “How’d you do today?” phone calls in the early days of the Mackinaw Kite Co.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d780b0b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nege_9781118044704_oeb_ded_r1.vue
// module id = 66
// module chunks = 0